import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from '@/store'
import '@/util/toast'

import BootstrapVue from 'bootstrap-vue'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import VModal from 'vue-js-modal'

import 'normalize.css'

import _ from 'lodash'
import device from 'current-device'

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faBullhorn,
  faChevronDown,
  faCog,
  faExpandArrowsAlt,
  faMapMarkerAlt,
  faPowerOff,
  faQuestionCircle,
  faSignOutAlt,
  faTimes,
  faUser
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VideoPlayer from 'vue-video-player'
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')

Vue.use(VideoPlayer)

library.add(faBullhorn, faChevronDown, faMapMarkerAlt, faPowerOff, faQuestionCircle, faCog, faTimes, faUser, faExpandArrowsAlt, faSignOutAlt)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.config.productionTip = false

Vue.use(BootstrapVue)

Vue.use(VModal)

Vue.prototype.$device = device

router.beforeEach((to, from, next) => {
  // console.log('to', to)
  // console.log('from', from)
  if (to.matched.some(record => record.meta.requiresLogin)) {
    // TODO 验证下用户是否登录 登录了是否有权限
    let username = store.state.user.username
    let role = store.state.user.role
    let result = ''
    if (username) {
      // let result = username?'authorised':'loginRequired';
      result = _.get(to, 'meta.requiredPermissions').indexOf(role) !== -1 ? 'authorised' : 'noPermission'
    } else {
      result = 'loginRequired'
    }

    switch (result) {
      // 未登录
      case 'loginRequired':
        Vue.toasted.global.pop_info('请先登录~')
        next({
          path: '/login', query: { redirect: to.fullPath }
        })
        break
      case 'authorised':
        next()
        break
      case 'noPermission':
        // next()
        Vue.toasted.global.pop_info('无权限访问~')
        next({ path: from.fullPath })
        break
    }
  } else {
    // 不需要登录
    next()
    // next({ path: '/login', query: { redirect: to.fullPath }
    // })
  }
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

Date.prototype.format = function (fmt) { // author: meizz
  var o = {
    'M+': this.getMonth() + 1, // 月份
    'd+': this.getDate(), // 日
    'h+': this.getHours(), // 小时
    'm+': this.getMinutes(), // 分
    's+': this.getSeconds(), // 秒
    'q+': Math.floor((this.getMonth() + 3) / 3), // 季度
    'S': this.getMilliseconds() // 毫秒
  }
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + '').substr(4 - RegExp.$1.length))
  }
  for (var k in o) {
    if (new RegExp('(' + k + ')').test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
    }
  }
  return fmt
}
